import { Alert, AlertTitle, Snackbar } from "@mui/material";
import React from "react";

function Notification(props) {
  const { notify, setNotify } = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      open={notify.isOpen}
      autoHideDuration={4000}
      sx={{ width: "100%" }}
      spacing={2}
    >
      {/* If you change variant also style overwrite in Theme.js file */}
      <Alert
        onClose={handleClose}
        icon={false}
        variant="filled"
        severity={notify.type}
      >
        <AlertTitle>{notify.type.toUpperCase()}</AlertTitle>
        {notify.message}
      </Alert>
    </Snackbar>
  );
}

export default Notification;
